import { useEffect } from 'react'
import {
  useParams,
  useNavigate,
  useResolvedPath,
} from 'react-router-dom-v5-compat'

import { useQuery } from '@apollo/client'

import { getFragmentData } from '~publish/gql'
import { usePostComposer } from '~publish/hooks/usePostComposer'

import { PostCard_Post } from '../PostCard'
import { useOnPostComposerClose } from './helpers'
import { GetPost } from './PostDetailsDialog/PostDetailsDialog'
import { PostErrorDialog } from './PostErrorDialog'

export function PostEditDialog(): JSX.Element | null {
  const resolvedPath = useResolvedPath('.')
  const { postId, id: channelId } = useParams<{ postId: string; id: string }>()
  const { editPostInComposer } = usePostComposer()
  const navigate = useNavigate()
  const { data, loading, error } = useQuery(GetPost, {
    variables: {
      id: postId ?? '',
    },
  })

  useEffect(() => {
    if (data?.post) {
      void editPostInComposer({
        postId: postId ?? '',
      })
    }
  }, [editPostInComposer, postId, channelId, data])

  useOnPostComposerClose(() => {
    navigate('..')
  })

  if (error) {
    return <PostErrorDialog error={error} />
  }

  if (data && !loading) {
    const post = getFragmentData(PostCard_Post, data.post)
    // This logic corrects the URL if the loaded post is from a different channel
    // This is an edge-case since we shouldn't link to a different channel on purpose.
    if (
      channelId &&
      post?.channel?.id &&
      channelId !== post.channel.id &&
      resolvedPath?.pathname
    ) {
      navigate(resolvedPath.pathname.replace(channelId, post.channel.id), {
        replace: true,
      })
    }
  }

  return null
}
